// nom des tpyes d'action des produits
export const LOAD_BEERS = "LOAD_BEERS";